import AppModal from "components/Modal"; 
import React, { 
    useEffect, 
    useState, 
}  from 'react';
import ReactDOM from "react-dom"; 
import { useAuth } from '../../../helpers/authContext';

import {
    // Alert,
    Button, 
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row, 
} from "reactstrap"; 
import { useToast } from "components/ui/use-toast"; 
import useModal from "helpers/useModal";
import LoginModal from "./LoginModal";
import { getUser } from "services/user-service"; 
import { isLoggedWithKeychain } from "services/dsteem-service";
import { transferKeychain } from "helpers/keychain";
import { transferWithWif } from "helpers/steem"; 
import { create_user_directory } from "services/db-service";
type Props = {
  isShowing: boolean,
  hide: any, 
  userDirectories?:any,
  symbol?:string,
  initialTo?: string,
  initialAmount?: string | number,
  initialMemo?: string,
  autoConfirm?: boolean,
  onSuccess?: () => void;
}

export const TransferModal = ({ isShowing, hide, userDirectories = [], symbol="STEEM", initialTo="", initialAmount="", initialMemo="", autoConfirm=false, onSuccess = null}: Props) => { 
    const { user, autologin } = useAuth(); 
    const [requiredActive, setRequiredActive] = useState<any>(true);
    const [saveContact, setSaveContact] = useState<any>(false);
    const [isTransferring, setIsTransferring] = useState(false); 
    const keychainLogin = isLoggedWithKeychain(autologin);
    const [availableSBD, setAvailableSBD] = useState<any>(0);
    const [availableSTEEM, setAvailableSTEEM] = useState<any>(0);
    const [contactName, setContactName] = useState<any>("");
    const [transferReceiver, setTransferReceiver] = useState<any>("");
    const [transferMemo, setTransferMemo] = useState<any>("");
    const [transferAmount, setTransferAmount] = useState<any | "">("");
    const [step, setStep] = useState<any>(1);
    const [menu, setMenu] = useState<any>(1);
    const [showConfirm, setShowConfirm] = useState(false);
    const [transferSymbol, setTransferSymbol] = useState<any>(symbol); 
    const { isOpenLoginModal, toggleLoginModal  } = useModal();
    const { toast } = useToast();
    useEffect(()=> { 
        if (isShowing) {
            setTransferSymbol(symbol);
            if (initialTo) setTransferReceiver(initialTo);
            if (initialAmount) setTransferAmount(initialAmount);
            if (initialMemo) setTransferMemo(initialMemo);
            if (autoConfirm && initialTo && initialAmount) {
                setShowConfirm(true);
            } else {
                setShowConfirm(false);
            }
        }
        async function getAvailableFunds (){
            try {
                const [userInfo] = await Promise.all([ 
                    getUser(user),
                ]);
                setAvailableSBD(parseFloat(userInfo?.sbd_balance) || 0)
                setAvailableSTEEM(parseFloat(userInfo?.balance) || 0)
            } catch (error) {
                toast({title:"Error", description:error, variant:"rose_red"});
            }
            
        }
        getAvailableFunds(); 
    },[isShowing]); 

    const handleNewContact = async (while_transfer = false) => { 
        if (!contactName || !transferReceiver) { 
            toast({
            title: "Failure while creating contact",
            description: `Please fill all the fields.`,
            variant:"rose_red"
            }); 
            return;
        }
        
        try {
            let new_item = { 
            username: user,
            transfer_user: transferReceiver,
            transfer_memo: transferMemo,
            contact_name: contactName ,
            type:"transfer"
            }
            const created = await create_user_directory(new_item);
            if (created) {
                if (!while_transfer) {
                    setContactName("");
                    setTransferReceiver("");
                    setTransferMemo("");
                    setMenu(2); 
                    if (onSuccess) {
                        onSuccess();
                    }
                }else {
                    setTransferAmount(0);
                    setTransferReceiver("");
                    setTransferMemo("");
                    setStep(1);
                    if (onSuccess) {
                        onSuccess();
                    } 
                    hide();
                } 
            }
            
        } catch (err) {
            console.error("Error creating contact:", err);
            toast({
            title: "Error creating contact",
            description: err,
            variant:"rose_red"
            }); 
        }
    }
    const handleTransfer = async (newWif = "") => { 
        if (transferAmount) { 
            const fn = keychainLogin ? transferKeychain : transferWithWif;
            const account = keychainLogin ? user : autologin; 
            setIsTransferring(true);
            let res:any = await fn(account, parseFloat(transferAmount), transferSymbol, transferReceiver, transferMemo, newWif);
            setIsTransferring(false);
            if (!res.success) { 
                if(res?.message.toString().includes("Missing Active Authority")){ 
                    setRequiredActive(true);
                    toggleLoginModal();
                    return;
                } else {
                   toast({
                        title:"Failed sending funds.",
                        description:res,
                        variant:"rose_red"
                    }); 
                }
                
            }else {
                toast({
                title:"Funds sent successfully.",
                description:"You have transferred funds to another Steem account.",
                variant:"wild_green"
                }); 
                if (saveContact) {
                    handleNewContact(true);
                }else {
                    setTransferAmount(0);
                    setTransferReceiver("");
                    setTransferMemo("");
                    setStep(1);
                    setShowConfirm(false);
                    if (onSuccess) {
                        onSuccess();
                    }
                    
                    hide();
                } 
            }
        }else{
            toast({
                title:"Failed sending funds.",
                description:"You need to set an amount.",
                variant:"rose_red"
            });
        }
    }
    const renderForm = (
        <div className="modal-body post-editor-body p-0">
        <Card className="no-shadow border-0">
            {user && menu == 1 && (
                <CardBody className="px-lg-3 py-lg-3 body-gray"> 
                    {step == 1 && (
                        <Row>
                            <Col md="12">
                                <p className="promotion-description">
                                    Move funds to another account.
                                </p>   
                            </Col>
                            <Col className="col-10">
                                <FormGroup>
                                    <div className="input-icon-group">
                                        <i className="fas fa-user input-icon" />
                                        <input type="text" className="form-control fancy-input" name="receiver" placeholder="Recipient" value={transferReceiver} onChange={(e) => setTransferReceiver((e.target.value))} />
                                    </div>
                                </FormGroup> 
                            </Col>
                            <Col className="col-2">
                                <Button className="directory-button" color="secondary" onClick={()=> setMenu(2)}><i className="fas fa-address-book" /></Button> 
                            </Col>
                            <Col className="col-8" md="8"> 
                                <FormGroup>
                                    <div className="input-icon-group">
                                        <i className="fas fa-coins input-icon" />
                                        <input type="number" className="form-control fancy-input" name="val" placeholder="Amount" value={transferAmount} onChange={(e) => setTransferAmount(parseFloat(e.target.value))} /> 
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col className="col-4" md="4"> 
                                <Input type="select" className="form-control fancy-input " name="symbol" value={transferSymbol} onChange={(e) => setTransferSymbol(e.target.value)} >
                                    <option value="STEEM">STEEM</option>
                                    <option value="SBD" >SBD</option>
                                </Input> 
                            </Col>
                            <Col md="12">
                                <div className="mb-3 d-flex justify-content-between">
                                    <small className="text-muted cursor-pointer">
                                        Available: <span onClick={() => {setTransferAmount(availableSBD);setTransferSymbol("SBD");}}>{availableSBD.toFixed(3)} SBD</span> | <span onClick={() => {setTransferAmount(availableSTEEM); setTransferSymbol("STEEM");}}>{availableSTEEM.toFixed(3)} STEEM</span>
                                    </small>
                                </div>
                            </Col> 
                            <Col md="12">
                                <FormGroup>
                                    <div className="input-icon-group">
                                        <i className="fas fa-comment-dots input-icon" />
                                        <input type="text" className="form-control fancy-input" name="memo" placeholder="Memo (Optional)" value={transferMemo} onChange={(e) => setTransferMemo((e.target.value))} />
                                    </div>
                                    <small className="text-muted" style={{fontSize: '10px'}}>* Required for some exchanges.</small>
                                </FormGroup> 
                            </Col> 
                            <Col className="col-12 mb-3">
                                <div className="mb-2">
                                    <Label check className="small text-muted">
                                        <input 
                                        type="checkbox" 
                                        checked={saveContact} 
                                        onChange={(e) => setSaveContact(e.target.checked)} 
                                        className="mr-2"
                                        />
                                        Save this contact to your directory?
                                    </Label>
                                </div>
                                {saveContact && (
                                    <FormGroup>
                                        <div className="input-icon-group">
                                            <i className="fas fa-id-card input-icon" />
                                            <input type="text" className="form-control fancy-input" name="contact" placeholder="Contact name (E.g: Binance)" value={contactName} onChange={(e) => setContactName((e.target.value))} />
                                        </div>
                                    </FormGroup> 
                                )}
                                
                            </Col>
                            <Col md="12"> 
                                <Button color="default" className="w-100 btn-fancy" onClick={() => {
                                    if (transferAmount && transferReceiver && transferSymbol) {
                                        if (saveContact && !contactName) {
                                            toast({title:"Enter a contact name first", description:"Set a proper name to identify this contact in your directory.", variant:"rose_red"});
                                            return;
                                        }
                                        setShowConfirm(true);
                                    }else {
                                        toast({title:"Fill all fields first", description:"Set a proper account name, amount, and symbol.", variant:"rose_red"});
                                    }
                                }}>
                                    Next <i className="fas fa-chevron-right ml-2" />
                                </Button> 
                            </Col>
                        </Row>
                    )}
                </CardBody>
            )}
            {user && menu == 2 && (
                <CardBody className="px-lg-3 py-lg-3 body-gray"> 
                        <Row>
                            <Col md="12">
                                <h4>
                                    Your directory list.
                                </h4>
                            </Col>
                            <Col md="12">
                                {userDirectories.map((directory, index) => {
                                    return(
                                        <div key={"directory-"+directory.id+"-"+index} className="directory-item mb-3" onClick={()=> {
                                            setTransferMemo(directory.transfer_memo);
                                            setTransferReceiver(directory.transfer_user);
                                            setMenu(1);
                                        }}>
                                            <span className="directory-icon">
                                                <i className="fas fa-user" />
                                            </span>
                                            <span className="directory-info">
                                                <span className="directory-name">{directory.contact_name}</span>
                                                <span className="directory-content">{directory.transfer_user} {directory.transfer_memo}</span>
                                            </span>
                                            
                                        </div>
                                    )
                                })}
                                {userDirectories.length == 0 &&(
                                    <div className="text-center">No contacts yet. </div>
                                )}
                            </Col>
                            <Col md="12" className="post-editor-buttons">
                                <Button  color="secondary" onClick={()=> setMenu(1)}><i className="fas fa-chevron-left" /> Back</Button> 
                                <Button color="default" onClick={() => setMenu(3)} style={{minWidth:"71px"}}>
                                    <i className="fas fa-plus" /> Add
                                </Button>  
                            </Col> 
                        </Row> 
                </CardBody>
            )}
            {user && menu == 3 && (
                <CardBody className="px-lg-3 py-lg-3 body-gray"> 
                    <Row>
                        <Col md="12">
                            <p className="promotion-description">
                                Add a new contact to your directory.
                            </p>   
                        </Col>
                        <Col className="col-12">
                            <FormGroup>
                                <div className="input-icon-group">
                                    <i className="fas fa-id-card input-icon" />
                                    <input type="text" className="form-control fancy-input" name="contact" placeholder="Contact name (E.g: Binance)" value={contactName} onChange={(e) => setContactName((e.target.value))} />
                                </div>
                            </FormGroup> 
                        </Col>
                        <Col className="col-12">
                            <FormGroup>
                                <div className="input-icon-group">
                                    <i className="fas fa-user input-icon" />
                                    <input type="text" className="form-control fancy-input" name="receiver" placeholder="Recipient" value={transferReceiver} onChange={(e) => setTransferReceiver((e.target.value))} />
                                </div>
                            </FormGroup> 
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <div className="input-icon-group">
                                    <i className="fas fa-comment-dots input-icon" />
                                    <input type="text" className="form-control fancy-input" name="memo" placeholder="Memo (Optional)" value={transferMemo} onChange={(e) => setTransferMemo((e.target.value))} />
                                </div>
                            </FormGroup> 
                        </Col>
                        <Col md="12" className="post-editor-buttons"> 
                            <Button  color="secondary" onClick={()=> setMenu(2)}><i className="fas fa-chevron-left" /> Back</Button>
                            <Button color="default" onClick={() => {
                                if (transferReceiver) {
                                    handleNewContact();
                                }else {
                                    toast({title:"Fill all fields first", description:"Set a proper account name, Memo, and contact name.", variant:"rose_red"});
                                }
                            }}>
                                Save 
                            </Button> 
                        </Col>
                    </Row> 
                </CardBody>
            )}
            {!user && (<p>Please log in to transfer funds.</p>)}
        </Card>
        </div>
    );

  return (
    isShowing ? ReactDOM.createPortal(
      <React.Fragment>
        <AppModal
          isShowing={isShowing}
          hide={hide}
          size="md"
          header="Transfer funds"
        >
            {renderForm}
            <AppModal isShowing={showConfirm} hide={() => !isTransferring && setShowConfirm(false)} size="md" header="Confirm Transfer">
                <div className="p-3 text-scheme">
                    <p className="text-muted">You are about to send funds. Please review the transaction details:</p>
                    <div className="mb-4 p-3 border rounded bg-speem-confirm">
                        <div className="mb-2">
                           <i className="fas fa-user mr-2 text-speem" /> <strong>Recipient:</strong> <span className="ml-2">@{transferReceiver}</span>
                        </div>
                        <div className="mb-2">
                           <i className="fas fa-coins mr-2 text-speem" /> <strong>Amount:</strong> <span className="ml-2">{parseFloat(transferAmount).toFixed(3)} {transferSymbol}</span>
                        </div>
                        <div className="mb-0">
                           <i className="fas fa-comment mr-2 text-speem" /> <strong>Memo:</strong> <span className="ml-2">{transferMemo || <em className="text-muted">No memo</em>}</span>
                        </div>
                    </div>
                    <div className="d-flex gap-3 mt-4">
                        <Button color="secondary" onClick={() => setShowConfirm(false)} disabled={isTransferring} className="w-100 mr-2 btn-fancy">
                            Cancel
                        </Button>
                        <Button color="default" onClick={() => handleTransfer()} disabled={isTransferring} className="w-100 btn-fancy position-relative">
                            {isTransferring ? (
                                <span className="spinner dark m-0" />
                            ) : keychainLogin ? (
                                <>
                                Confirm with
                                <img className="icon icon-sm ml-1" src="/assets/img/keychain.svg" />
                                </>
                            ) : (
                                "Confirm"
                            )}
                        </Button>
                    </div>
                </div>
            </AppModal>
        </AppModal>
        <LoginModal
            isShowing={isOpenLoginModal}
            hide={toggleLoginModal}
            requiredActive={requiredActive}
            onSuccess={({ wif }) => { 
                if (wif) {
                handleTransfer(wif);
                } 
            }}
            />
      </React.Fragment>, document.body
    ) : null)
};

export default TransferModal;